module.exports = __webpack_public_path__ + "static/media/10.303e0a48.jpg";